import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { TowersInfoModalComponent } from '@features/towers/modals/towers-info-modal/towers-info-modal.component';

export function provideTowersModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TowersInfoModalComponent', component: TowersInfoModalComponent }, multi: true },
  ];
}
